const featureData = [
  {
    icon: 'ri-flashlight-fill',
    title: '极速追踪',
    desc: '7×24小时全网监控，重大爆料5分钟内上线，永远快人一步获取最新黑料动态。',
  },
  {
    icon: 'ri-database-2-fill',
    title: '全平台覆盖',
    desc: '覆盖微博、抖音、小红书、豆瓣等50+主流平台，一站聚合全网吃瓜内容。',
  },
  {
    icon: 'ri-shield-check-fill',
    title: '严格审核',
    desc: '专业编辑团队多层审核机制，去伪存真，确保每一条爆料内容真实可靠。',
  },
  {
    icon: 'ri-layout-grid-fill',
    title: '分类清晰',
    desc: '按娱乐圈、网红圈、商业圈等维度精细分类，快速定位你感兴趣的瓜田。',
  },
  {
    icon: 'ri-smartphone-fill',
    title: '多端适配',
    desc: '完美适配手机、平板和电脑端浏览，随时随地畅快吃瓜不卡顿。',
  },
];

export default function SectionFeatures() {
  return (
    <section id="features" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[1080px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            为什么选择五一黑料网
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            数百万吃瓜群众信赖的爆料聚合平台
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {featureData.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-5 text-center hover:bg-background-200 transition-colors duration-200 group cursor-pointer"
            >
              <span className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="text-sm md:text-base font-semibold text-foreground-800 mb-2">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}